<h1 *ngIf="!isRobotProvisionAvailable"
    matDialogTitle>{{ title | translate }}</h1>

<mat-tab-group [hidden]="!isRobotProvisionAvailable"
               matDialogTitle
               dynamicHeight="true"
               class="tab-header">
    <mat-tab #generalTab
             [label]="title | translate">
    </mat-tab>
    <mat-tab #settingsTab
             [disabled]="context.data.type === UserType.Robot"
             [label]="'user_modal_title_robot_settings' | translate">
    </mat-tab>
</mat-tab-group>

<form [formGroup]="form"
      (submit)="onSubmit()"
      uiPreventAutofill>
    <mat-dialog-content>
        <section [hidden]="!generalTab.isActive">
            <mat-form-field *ngIf="context.data.type === UserType.User">
                <input [uiAutofocus]="context.isNewEntry"
                       [readonly]="context.isNewEntry ? null : 'readonly'"
                       [placeholder]="'user_modal_form_username' | translate"
                       matInput
                       formControlName="userName"
                       name="userName"
                       class="form-control"
                       required
                       data-cy="user-form-username" />
                <mat-hint *ngIf="!form.get('userName')!.pristine &&
                            form.get('userName')!.hasError('maxlength')"
                          [translateParams]="form.get('userName')!.getError('maxlength')"
                          translate
                          class="errorMessage">
                    user_modal_form_username_max_warning
                </mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="context.data.type === UserType.User">
                <input [uiAutofocus]="!context.isNewEntry"
                       [placeholder]="'user_modal_form_name' | translate"
                       matInput
                       formControlName="name"
                       name="name"
                       class="form-control"
                       data-cy="user-form-name" />
                <mat-hint *ngIf="!form.get('name')!.pristine &&
                            form.get('name')!.hasError('maxlength')"
                          [translateParams]="form.get('name')!.getError('maxlength')"
                          translate
                          class="errorMessage">
                    user_modal_form_name_max_warning
                </mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="context.data.type === UserType.User">
                <input [placeholder]="'user_modal_form_surname' | translate"
                       matInput
                       formControlName="surname"
                       name="surname"
                       class="form-control"
                       data-cy="user-form-surname" />
                <mat-hint *ngIf="!form.get('surname')!.pristine &&
                            form.get('surname')!.hasError('maxlength')"
                          [translateParams]="form.get('surname')!.getError('maxlength')"
                          translate
                          class="errorMessage">
                    user_modal_form_surname_max_warning
                </mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="context.data.type === UserType.User">
                <input [placeholder]="'user_modal_form_email' | translate"
                       [readonly]="disallowEmailChange && !context.isNewEntry"
                       matInput
                       formControlName="emailAddress"
                       name="emailAddress"
                       class="form-control"
                       data-cy="user-form-email" />
                <mat-hint *ngIf="!form.get('emailAddress')?.pristine &&
                            !form.get('emailAddress')?.hasError('email') &&
                            form.get('emailAddress')?.hasError('maxlength')"
                          [translateParams]="form.get('emailAddress')?.getError('maxlength')"
                          translate
                          class="errorMessage">
                    user_modal_form_email_max_warning
                </mat-hint>
                <mat-hint *ngIf="!form.get('emailAddress')?.pristine &&
                            form.get('emailAddress')?.hasError('email')"
                          translate
                          class="errorMessage">
                    user_modal_form_email_invalid_warning
                </mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="context.data.type === UserType.User">
                <input #passwordInput
                       [placeholder]="'user_modal_form_password' | translate"
                       matInput
                       uiPreventAutofill
                       formControlName="password"
                       name="password"
                       class="form-control"
                       type="password"
                       data-cy="user-form-password" />
                <span matSuffix>
                    <ui-password-toggle [element]="passwordInput"
                                        [tooltipShow]="'password_toggle_show' | translate"
                                        [tooltipHide]="'password_toggle_hide' | translate"
                                        data-cy="user-form-password-toggle"></ui-password-toggle>
                </span>
            </mat-form-field>
            <ui-password-indicator *ngIf="!form.get('password')?.pristine &&
                                    form.get('password')?.hasError('complexity')"
                                   [state]="form.get('password')?.getError('complexity')"
                                   [passwordComplexity]="passwordComplexity">
            </ui-password-indicator>
            <mat-form-field *ngIf="context.data.type === UserType.User">
                <input #confirmPasswordInput
                       [placeholder]="'user_modal_form_confirm_password' | translate"
                       matInput
                       uiPreventAutofill
                       formControlName="confirmPassword"
                       name="confirmPassword"
                       class="form-control"
                       type="password"
                       data-cy="user-form-confirm-password" />
                <span matSuffix>
                    <ui-password-toggle [element]="confirmPasswordInput"
                                        [tooltipShow]="'password_toggle_show' | translate"
                                        [tooltipHide]="'password_toggle_hide' | translate"></ui-password-toggle>
                </span>
                <mat-hint *ngIf="!form.get('confirmPassword')?.pristine &&
                            form.get('confirmPassword')?.hasError('nomatch')"
                          translate
                          class="errorMessage">
                    user_modal_form_confirm_password_warning
                </mat-hint>
            </mat-form-field>
            <div *ngIf="isBasicAuthRestricted"
                 class="checkbox-container">
                <mat-checkbox [uiClickTrack]="'User Modal: Toggle Basic Auth'"
                              formControlName="bypassBasicAuthRestriction"
                              data-cy="user-bypass-disabled-basic-auth">
                    {{ 'user_modal_form_bypass_disabled_basic_auth' | translate }}
                </mat-checkbox>
            </div>
            <mat-form-field>
                <ui-suggest [searchable]="true"
                            [searchSourceFactory]="roleSearchFactory"
                            [placeholder]="'user_modal_form_roles' | translate"
                            [defaultValue]="'user_modal_form_roles_empty' | translate"
                            [multiple]="true"
                            [displayCount]="5"
                            [direction]="UserType.User === context.data.type ? 'up' : 'down'"
                            formControlName="rolesList"
                            data-cy="user-form-roles">
                </ui-suggest>
            </mat-form-field>

            <ng-container *ngIf="UserType.Robot !== context.data.type">
                <mat-slide-toggle *uiModernContext
                                  formControlName="mayHaveUserSession">
                    <span translate>user_modal_robot_may_have_user_session</span>
                </mat-slide-toggle>
            </ng-container>

        </section>

        <ng-container *ngIf="isRobotProvisionAvailable">
            <section [hidden]="!settingsTab.isActive">
                <mat-slide-toggle *ngLet="isRobotSwitcherEnabled$ | async as isRobotSwitcherEnabled"
                                  [disabled]="!isRobotSwitcherEnabled"
                                  [matTooltip]="isRobotSwitcherEnabled ? '' : ('authorize_no_permissions' | translate)"
                                  [uiClickTrack]="'User Modal: Toggle Robot Provisioning'"
                                  formControlName="mayHaveRobotSession"
                                  class="may-have-robot-switch">
                    <span translate>user_modal_robot_autoprovision_user</span>
                </mat-slide-toggle>

                <ui-user-provision-robot *ngLet="isRobotEditable$ | async as isRobotEditable"
                                         [robot]="context.data.robotProvision"
                                         [enabled]="form.get('mayHaveRobotSession')!.value && isRobotEditable"
                                         [matTooltip]="isRobotEditable ? '' : ('authorize_no_permissions' | translate)"
                                         [userType]="context.data.type">
                </ui-user-provision-robot>
            </section>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                        loading: loading$ | async
                    } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button"
                data-cy="user-form-cancel">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                        form.invalid"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary"
                data-cy="user-form-submit">
            {{ (context.isNewEntry ? 'modal_action_create' : 'modal_action_update') | translate }}
        </button>
    </mat-dialog-actions>
</form>
